<ng-template #template>
    <div class="modal-body position-relative pt-12">
        <div class="text-dark-75 h2 mb-10 ml-{{marginLeft}}">{{ message }}
            <button type="button" class="close" (click)="cancel()"><i aria-hidden="true"
                    class="ki ki-close"></i></button>
        </div>
        <div class="text-dark-50 mb-10 ml-{{marginLeft}}">
            {{ submessage }}
        </div>
        <ng-content></ng-content>
        <div class="d-flex" [ngClass]="{'justify-content-center': hideCancelButton}">
            <button class="btn btn-outline-danger rounded-0 w-50 mx-6" *ngIf="!hideCancelButton"
                (click)="cancel()">{{'No'|localize}}</button><button class="btn btn-primary rounded-0 mx-6"
                [ngClass]="{'w-25': hideCancelButton, 'w-50': !hideCancelButton}" (click)="yes()">{{customYesText ?
                customYesText : 'Yes'|localize}}</button>
        
            </div>        
        <span class="position-absolute modal-icon">
            <img *ngIf="modalType === 1" src="../../../.././../assets/common/images/modalpopup/Group 147527.svg" class="modal-body span img ">
            <img *ngIf="modalType === 2" src="../../../.././../assets/common/images/modalpopup/Group 147522.svg" class="modal-body span img ">
            <img *ngIf="modalType === 3" src="../../../.././../assets/common/images/modalpopup/Group 147525.svg" class="modal-body span img ">
        </span>
    </div>
</ng-template>